/**
 * Check if a given object implements the CountAvailableQuestionContentsResponse interface.
 */
export function instanceOfCountAvailableQuestionContentsResponse(value) {
    let isInstance = true;
    isInstance = isInstance && "count" in value;
    return isInstance;
}
export function CountAvailableQuestionContentsResponseFromJSON(json) {
    return CountAvailableQuestionContentsResponseFromJSONTyped(json, false);
}
export function CountAvailableQuestionContentsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'count': json['count'],
    };
}
export function CountAvailableQuestionContentsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'count': value.count,
    };
}
